import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getEvaluationScales } from '../api';
import { EvaluationScalesResponse } from '../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  EvaluationScalesResponse[],
  AxiosResultDefaultError
>();

export function useSurveyEvaluationScalesListLoader() {
  return useFetch();
}

export const SurveyEvaluationScalesListLoaderConsumer = FetchConsumer;

export default function SurveyEvaluationScalesListLoader({
  children,
}: BaseLoaderProps) {
  const request = useCallback(async () => {
    return getEvaluationScales();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
